var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin-icon",
    transform: "translate(-424 -579)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bgr",
    width: 32,
    height: 32,
    transform: "translate(424 579)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "linkedin-fill-svgrepo-com",
    d: "M26,3.765V24.235A1.765,1.765,0,0,1,24.235,26H3.765A1.765,1.765,0,0,1,2,24.235V3.765A1.765,1.765,0,0,1,3.765,2H24.235A1.765,1.765,0,0,1,26,3.765ZM9.059,11.176H5.529V22.471H9.059Zm.318-3.882A2.033,2.033,0,0,0,7.358,5.247H7.294A2.057,2.057,0,1,0,9.376,7.358Zm13.094,8.315c0-3.4-2.16-4.715-4.306-4.715a4.024,4.024,0,0,0-3.572,1.821h-.1V11.176H11.176V22.471h3.529V16.463a2.343,2.343,0,0,1,2.118-2.527h.134c1.122,0,1.955.706,1.955,2.485v6.049h3.529Z",
    transform: "translate(426 581)",
    fill: "#0273b1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b9c0145c982a7b0dc9a159529d4d343b.svg";
export { ForwardRef as ReactComponent };